var Os = function() {
    var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid : isAndroid,
        isPc : isPc
    };
}();
if(Os.isPc)
{
    window.platform = "pc";
}else{
    window.platform = "mobile";
}

// 判断平台并且跳转
// 如果域名是pc 设备是手机，就跳转到手机的域名上
if((window.location.hostname === 'vgoglove.com' || window.location.hostname === 'www.vgoglove.com') && window.platform === "mobile"){
    var url = 'https://m.vgoglove.com'+window.location.pathname+window.location.search
    window.location.href = url
}
// 如果域名是mobile 设备是pc 就跳转到pc 上
if(window.location.hostname === 'm.vgoglove.com' && window.platform === "pc"){
    var url = 'https://vgoglove.com'+window.location.pathname+window.location.search
    window.location.href = url
}